<div class="main-container">
    <div class="header-container">

        <div class="title-container">
            <h1>Partnership Dashboard</h1>
        </div>

        <div class="action-items" style="justify-content: end;">

            <div class="entity-filter-container">

                @if (!hoLoading && !contentLoading && selectedPartnership.le_name) {
<div class="entity-container">
                    <div class="entity-info">
                        <h2>{{selectedPartnership.le_name}}</h2>
                        <p>{{selectedPartnership.ein_num}} |
                            {{selectedPartnership.year_begin}}-{{selectedPartnership.year_end}}</p>
                    </div>
                </div>
}
            </div>
            <span style="font-weight: 700;cursor:pointer; margin-left:10px" class="filter-icon"
                (click)="showFilter()">Filter
                <span class=" Appkit4-icon icon-filter-outline">
                    @if (selectedFilterParams!=undefined) {
<i class="fa fa-circle"
                        style="font-size: 8px;color: #D04A02;padding-left: 2px;padding-bottom: 6px;padding-top: 0px;"></i>
}
                </span>
            </span>
        </div>

    </div>
    <div [hidden]="isShow">

        <gtw-dashboard-filter
            (close-dashboard-filter)="closeFilterPanel($event)"
            (loadDataTableEmitter)="saveFilters($event)"></gtw-dashboard-filter>
    </div>

    <app-loader [loaded]="!hoLoading" style="position: relative;top:25%">

    </app-loader>
    @if (hoLoading) {
<div class="gg-loader" style="width: 100% !important;height: calc(100vh - 230px)!important;">
        <div class="gg-loader-text">
            @if (loading) {
<img src="assets/img/arrow-filter-sm.png">
}
        </div>
    </div>
}
    @if (!hoLoading) {
<div class="main-content">
        <div class="partnership-sidebar">
            <div class="partnership-container">
                <div class="pship-toggle">
                    <span style="margin-right: 5px;">Partnership</span>
                    <ap-toggle (onChange)="switch($event)" [styleClass]="'a-m-5'" [disabled]="true">
                        Partners
                    </ap-toggle>
                </div>
                <hr class="dropdown-divider">
                <div class="list-section">
                    <div class="list-container-left">
                        <ap-list [bordered]="false" [styleClass]="'partnership-list'" [role]="'listbox'">
                            @for (partnership of partnerships; track partnership) {
<ap-list-item
                                [class.selected]="isPartnershipSelected(partnership)"
                                [attr.role]="'option'"
                                [attr.aria-selected]="isPartnershipSelected(partnership)"
                                [attr.aria-label]="partnership.label"
                                (click)="selectPartnership({ value: partnership.value })"
                                (keyup.enter)="selectPartnership({ value: partnership.value })">
                                <div class="partnership-item">
                                    <div>
                                        @for (key of objectKeys(partnership.value.leidMap); track $index) {
<span>
                                            {{key}}
                                        </span>
}
                                    </div>
                                    <!-- <span class="Appkit4-icon icon-right-chevron-outline"></span> -->
                                </div>
                            </ap-list-item>
}
                        </ap-list>
                    </div>
                    <div class="list-container-right">
                        <ap-list [bordered]="false" [styleClass]="'partner-list'" [role]="'listbox'">
                            @for (partner of partnersOptions; track $index) {
<ap-list-item [attr.role]="'option'" [attr.aria-disabled]="'true'" [attr.tabindex]="-1"
                                [attr.aria-label]="partner.label">
                                <div class="partner-item">
                                    <div>
                                        {{partner.label}}%
                                    </div>
                                </div>
                            </ap-list-item>
}
                        </ap-list>
                    </div>

                </div>
            </div>

        </div>

        <div class="content">
            <app-loader [loaded]="!contentLoading" style="position: fixed;top:25%;left:55%;">

            </app-loader>
            @if (!contentLoading) {
<div>
                <div class="financial-cards">
                    <div class="cards-spacing card-details">

                        <div id="ti" class="card-header-cust" (click)="selectCard($event)"
                            (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)"
                            [class.clickable-cursor]="isClickable">
                            <div class="taxable-icon">
                                <i class="pi pi-money-bill" style="font-size: 1rem; color: #175C2C;"></i>
                            </div>

                            <span style="font-weight: 500 !important;"> Taxable Income</span>
                        </div>
                        <div class="card-content">
                            <div class="content-row">
                                <span>Partnership</span>
                                <span>{{ti_card_details.total_amt | numberWithCommas }}</span>
                            </div>
                            <div class="content-row">
                                <span>Flowthrough</span>
                                <span>{{ti_card_details.total_flowthru_amt | numberWithCommas }}</span>
                            </div>
                            <div class="content-row">
                                <span>Exclusion</span>
                                <span>{{ti_card_details.total_exclusion_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>External</span>
                                <span>{{ti_card_details.total_ext_ptr_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Variance</span>
                                <span>{{ti_card_details.variance | numberWithCommas}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="cards-spacing card-details">

                        <div id="creds" class="card-header-cust" (click)="selectCard($event)"
                            (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)"
                            [class.clickable-cursor]="isClickable">
                            <div class="credits-icon">
                                <i class="pi pi-credit-card" style="font-size: 1rem; color: #003DAB;"></i>
                            </div>
                            <span> Credits</span>
                        </div>
                        <div class="card-content">
                            <div class="content-row">
                                <span>Partnership</span>
                                <span>{{credits_card_details.total_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Flowthrough</span>
                                <span>{{credits_card_details.total_flowthru_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Exclusion</span>
                                <span>{{credits_card_details.total_exclusion_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>External</span>
                                <span>{{credits_card_details.total_ext_ptr_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Variance</span>
                                <span>{{credits_card_details.variance | numberWithCommas}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="cards-spacing card-details">

                        <div id="source" class="card-header-cust" (click)="selectCard($event)"
                            (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)"
                            [class.clickable-cursor]="isClickable">
                            <div class="sourcing-icon">
                                <i class="pi pi-box" style="font-size: 1rem; color: #141414;"></i>
                            </div>

                            <span> Sourcing</span>
                        </div>
                        <div class="card-content">
                            <div class="content-row">
                                <span>Partnership</span>
                                <span>{{sourcing_card_details.total_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Flowthrough</span>
                                <span>{{sourcing_card_details.total_flowthru_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Exclusion</span>
                                <span>{{sourcing_card_details.total_exclusion_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>External</span>
                                <span>{{sourcing_card_details.total_ext_ptr_amt | numberWithCommas}}</span>
                            </div>
                            <div class="content-row">
                                <span>Variance</span>
                                <span>{{sourcing_card_details.variance | numberWithCommas}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="data-table">

                    <div class="partnership-grid-caption">{{ gridTitle }}</div>
                    <div class="partnership-grid-scroll">
                      <table mat-table [dataSource]="tableData || []" class="partnership-mat-table">
                        <ng-container matColumnDef="LEID">
                          <th mat-header-cell *matHeaderCellDef>Partnership Entity</th>
                          <td mat-cell *matCellDef="let item">{{ item.LEID }}</td>
                        </ng-container>
                        <ng-container matColumnDef="CDR_NO">
                          <th mat-header-cell *matHeaderCellDef>Tax Code</th>
                          <td mat-cell *matCellDef="let item">{{ item.CDR_NO }}</td>
                        </ng-container>
                        <ng-container matColumnDef="REPORTING_PERIOD">
                          <th mat-header-cell *matHeaderCellDef>Reporting Period</th>
                          <td mat-cell *matCellDef="let item">{{ item.REPORTING_PERIOD }}</td>
                        </ng-container>
                        <ng-container matColumnDef="ME_CODE">
                          <th mat-header-cell *matHeaderCellDef>Business Unit</th>
                          <td mat-cell *matCellDef="let item">{{ item.ME_CODE }}</td>
                        </ng-container>
                        <ng-container matColumnDef="TOTAL_PSHIP_AMT">
                          <th mat-header-cell *matHeaderCellDef class="text-right">Partnership Total</th>
                          <td mat-cell *matCellDef="let item" class="text-right">{{ item.TOTAL_PSHIP_AMT | numberWithCommas }}</td>
                        </ng-container>
                        <ng-container matColumnDef="TOTAL_FLOWTHRU_AMT">
                          <th mat-header-cell *matHeaderCellDef class="text-right">Internal Partner Flowthrough</th>
                          <td mat-cell *matCellDef="let item" class="text-right">{{ item.TOTAL_FLOWTHRU_AMT | numberWithCommas }}</td>
                        </ng-container>
                        <ng-container matColumnDef="TOTAL_EXCLUSION_AMT">
                          <th mat-header-cell *matHeaderCellDef class="text-right">Exclusion</th>
                          <td mat-cell *matCellDef="let item" class="text-right">{{ item.TOTAL_EXCLUSION_AMT | numberWithCommas }}</td>
                        </ng-container>
                        <ng-container matColumnDef="TOTAL_EXT_PTR_AMT">
                          <th mat-header-cell *matHeaderCellDef class="text-right">External Partner Flowthrough</th>
                          <td mat-cell *matCellDef="let item" class="text-right">{{ item.TOTAL_EXT_PTR_AMT | numberWithCommas }}</td>
                        </ng-container>
                        <ng-container matColumnDef="VARIANCE">
                          <th mat-header-cell *matHeaderCellDef class="text-right">Variance</th>
                          <td mat-cell *matCellDef="let item" class="text-right">{{ item.VARIANCE | numberWithCommas }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="partnershipDisplayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: partnershipDisplayedColumns"></tr>
                      </table>
                    </div>

                </div>
            </div>
}



        </div>
    </div>
}
</div>